import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { IntlProvider } from "react-intl"
import { BrowserRouter } from "react-router";
import { DEFAULT_LOCALE, translationMessages } from "./translations/language";
import './index.css';
import App from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <BrowserRouter>
          <IntlProvider locale={DEFAULT_LOCALE} messages={translationMessages}>
            <App />
          </IntlProvider>
      </BrowserRouter>
  </StrictMode>,
)
